import React from "react";

interface ILastPartCtx {
  clearLastPart: () => void;
  lastPart: number | null;
}

const LastPartCtx = React.createContext<ILastPartCtx>({
  clearLastPart: () => {
    return;
  },
  lastPart: null,
});

export const LastPartProvider = LastPartCtx.Provider;

export default LastPartCtx;
